//default index file created by jakeCLI 1.0 11:08:35 GMT+0300 (Eastern European Summer Time)
export { default as AdminTable } from './AdminTable'
export { default as StyledAdminTable } from './AdminTable.Styled'

export type CellValue<T> = {
  cell: {
    value: T;
  };
}
